import { Directive, HostListener } from '@angular/core';

import { RootScopeService } from '../shared-service/root-scope.service';
import { RootScopeDeclare } from '../rootscope-declare';

@Directive({
  selector: '[appScreenSize]'
})
export class ScreenSizeDirective {

  rootScopeData: RootScopeDeclare;
  scrWidth: number;

  constructor(private rootScopeService: RootScopeService) {
    this.getRootScopeData();
    this.setScreenSize();
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
  }

  @HostListener('window:resize', ['$event'])
  setScreenSize(): void {
    this.scrWidth = window.innerWidth;
    if (this.scrWidth >= 1200) {
      this.rootScopeData.screenSize = 'xl';
    } else if (this.scrWidth >= 1024) {
      this.rootScopeData.screenSize = 'lg';
    } else if (this.scrWidth >= 768) {
      this.rootScopeData.screenSize = 'md';
    } else if (this.scrWidth >= 576) {
      this.rootScopeData.screenSize = 'sm';
    } else {
      this.rootScopeData.screenSize = 'xs';
    }
    this.setDeviceType();
  }

  setDeviceType(): void {
    let body = <HTMLElement>document.querySelector('body');
    let _css = '';

    if (navigator.userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/i)) {
      const landscape = (window.orientation === 90 || window.orientation === -90);
      if ((this.rootScopeData.screenSize === 'md' && !landscape) || (this.rootScopeData.screenSize === 'lg') || (this.rootScopeData.screenSize === 'xl')) {
        _css = 'tablet';
      } else {
        _css = 'phone';
      }
    } else {
      _css = 'pc';
    }
    this.rootScopeData.deviceType = _css;
    body.classList.add(`body-${_css}`);

  }

}
